import React from 'react';
import { Target, Heart, CheckCircle } from 'lucide-react';
import OrderCTA from '../components/OrderCTA';

import aboutBg from '../assets/aboutbg.webp';

const About = () => {
    return (
        <div>
            <section
                className="relative text-white py-40 px-4 sm:px-6 lg:px-8 text-center overflow-hidden bg-cover bg-bottom min-h-[80vh] flex flex-col justify-center"
                style={{ backgroundImage: `url(${aboutBg})` }}
            >
                <div className="absolute inset-0 bg-black opacity-50"></div>
                <div className="relative z-10 max-w-4xl mx-auto">
                    <h1 className="text-4xl md:text-6xl font-bold mb-6 font-serif text-secondary">About Us</h1>
                    <p className="text-xl md:text-2xl text-green-50 max-w-3xl mx-auto">
                        Premium Textile Manufacturing for Bulk Excellence Quality, Innovation, and Sustainability in Every Thread.
                    </p>
                </div>
            </section>

            <section className="py-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-start">
                    <div>
                        <h2 className="text-3xl font-bold mb-6 text-primary">Our Story</h2>
                        <p className="text-gray-600 mb-4 leading-relaxed">
                            Thread and Needle Valley is a leading textile manufacturer committed to excellence in quality, innovation, and sustainability. With a rich history spanning over 3 years, we have established ourselves as a trusted name in the textile industry, renowned for our superior products and customer-centric approach. Our state-of-the-art manufacturing facilities and dedicated team enable us to deliver a diverse range of textiles that meet the highest industry standards.
                        </p>
                        <p className="text-gray-600 mb-4 leading-relaxed">
                            We understand that every client has unique needs. That's why we built our business model around <strong>customization</strong>. Whether you need a specific thread count, a unique color dye, or a custom pattern print, our facility is equipped to handle it.
                        </p>

                        <p className="text-gray-600 mb-4 leading-relaxed">
                            At Thread and Needle Valley, we are driven by our commitment to innovation, quality, and sustainability. We continuously invest in research and development to stay ahead of industry trends and exceed our customers' expectations. Our focus on ethical practices, responsible sourcing, and environmental stewardship underpins our dedication to creating value for our stakeholders and contributing positively to the communities we serve.
                        </p>

                        <div className="mt-8 space-y-6">
                            <div>
                                <h2 className="text-3xl font-bold mb-6 text-primary">Our Mission</h2>
                                <p className="text-gray-600 leading-relaxed">
                                    Our mission is to produce high-quality, innovative textiles that meet the diverse needs of our customers while upholding the highest standards of sustainability and ethical practices.</p>
                            </div>
                            <div>
                                <h2 className="text-3xl font-bold mb-6 text-primary">Our Vision</h2>
                                <p className="text-gray-600 leading-relaxed">
                                    Our vision is to become a global leader in textile manufacturing, recognized for our commitment to innovation, quality and sustainability. We aim to set new standards in the textile industry.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="bg-white p-8 rounded-xl shadow-lg border-l-4 border-primary">
                        <h3 className="text-2xl font-bold mb-6 text-dark">Our Core Values</h3>
                        <ul className="space-y-6">
                            <li className="flex gap-4">
                                <div className="mt-1"><Target className="text-primary" size={24} /></div>
                                <div>
                                    <h4 className="font-bold text-lg">Precision</h4>
                                    <p className="text-gray-600 text-sm">Exact measurements and specifications for every order.</p>
                                </div>
                            </li>
                            <li className="flex gap-4">
                                <div className="mt-1"><Heart className="text-primary" size={24} /></div>
                                <div>
                                    <h4 className="font-bold text-lg">Quality</h4>
                                    <p className="text-gray-600 text-sm">Premium materials that stand the test of time.</p>
                                </div>
                            </li>
                            <li className="flex gap-4">
                                <div className="mt-1"><CheckCircle className="text-primary" size={24} /></div>
                                <div>
                                    <h4 className="font-bold text-lg">Integrity</h4>
                                    <p className="text-gray-600 text-sm">Honest timelines and transparent communication.</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>

            <OrderCTA title="Partner With Us" />
        </div>
    );
};

export default About;
